import { Component } from 'react';
import Bugsnag from '../../helpers/bugsnag';

class ChangingProgressProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valuesIndex: 0,
    };
  }

  componentDidMount() {
    try {
      const { onManageCases } = this.props;
      const myInterval = setInterval(() => {
        if (this.props.intervalId >= 12) {
          clearInterval(myInterval);
          onManageCases();
        }
        this.setState({
          valuesIndex: (this.state.valuesIndex + 1) % this.props.values.length
        });
      }, 400);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (this.props.children(this.props.values[this.state.valuesIndex]));
  }
}

export default ChangingProgressProvider;
